/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDiscountOrigin } from './OrderDiscountOrigin';
import {
    OrderDiscountOriginFromJSON,
    OrderDiscountOriginFromJSONTyped,
    OrderDiscountOriginToJSON,
    OrderDiscountOriginToJSONTyped,
} from './OrderDiscountOrigin';
import type { OrderDiscountType } from './OrderDiscountType';
import {
    OrderDiscountTypeFromJSON,
    OrderDiscountTypeFromJSONTyped,
    OrderDiscountTypeToJSON,
    OrderDiscountTypeToJSONTyped,
} from './OrderDiscountType';

/**
 * 
 * @export
 * @interface MenuOrderDiscount
 */
export interface MenuOrderDiscount {
    /**
     * 
     * @type {string}
     * @memberof MenuOrderDiscount
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderDiscount
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderDiscount
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderDiscount
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderDiscount
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderDiscount
     */
    expiresAt?: number;
    /**
     * 
     * @type {OrderDiscountOrigin}
     * @memberof MenuOrderDiscount
     */
    origin: OrderDiscountOrigin;
    /**
     * 
     * @type {OrderDiscountType}
     * @memberof MenuOrderDiscount
     */
    type: OrderDiscountType;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderDiscount
     */
    reference?: string;
}



/**
 * Check if a given object implements the MenuOrderDiscount interface.
 */
export function instanceOfMenuOrderDiscount(value: object): value is MenuOrderDiscount {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function MenuOrderDiscountFromJSON(json: any): MenuOrderDiscount {
    return MenuOrderDiscountFromJSONTyped(json, false);
}

export function MenuOrderDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderDiscount {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'code': json['code'] == null ? undefined : json['code'],
        'amount': json['amount'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'origin': OrderDiscountOriginFromJSON(json['origin']),
        'type': OrderDiscountTypeFromJSON(json['type']),
        'reference': json['reference'] == null ? undefined : json['reference'],
    };
}

export function MenuOrderDiscountToJSON(json: any): MenuOrderDiscount {
    return MenuOrderDiscountToJSONTyped(json, false);
}

export function MenuOrderDiscountToJSONTyped(value?: MenuOrderDiscount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'description': value['description'],
        'code': value['code'],
        'amount': value['amount'],
        'priority': value['priority'],
        'expiresAt': value['expiresAt'],
        'origin': OrderDiscountOriginToJSON(value['origin']),
        'type': OrderDiscountTypeToJSON(value['type']),
        'reference': value['reference'],
    };
}

